<template lang="pug">
.hello
  section#hero
    .container
      .row
        .col-12.col-md-6
          h2 Bookkeeping made simple
          p Small Business Bookkeeping make bookkeeping #[strong smart], #[strong fast], and #[strong simple].
          main-contact
        .col-12.col-md-6(style="display: flex;")
          img(src='../assets/finance.svg')
  section#how.container
    .row
      .col-12
        h2 Here's how it works
    .row
      .col-md-4
        .card-item
          h3 Step 1
          p Securely connect your accounts with our account integration. This allows us to sync directly with all major banks to automatically pull your transactions into Small Business Bookkeeping.
      .col-md-4
        .card-item
          h3 Step 2
          p Our service will provide monthly financial statements and consulting to meet all your bookkeeping needs.
      .col-md-4
        .card-item
          h3 Step 3
          p We provide affordable, simple bookkeeping so you can focus on your business
  section#pricing.container
    .row
      h2.col-12 Pricing
    .row
      .col-md-3
        .card-item
          h3 Essentials
          .number $150/mo
          p Monthly expenses below $7.5k
          p Up To 3 Accounts
          .text-center
            a.btn.btn-primary(href='#register') Get Started
      .col-md-3
        .card-item
          h3 Ramping Up
          .number $200/mo
          p Monthly expenses from $7.5k to $20k
          p Up To 5 Accounts
          .text-center
            a.btn.btn-primary(href='#register') Get Started
      .col-md-3
        .card-item
          h3 Pro
          .number $300/mo
          p Monthly expenses from $20k to $60k
          p Up To 10 Accounts
          .text-center
            a.btn.btn-primary(href='#register') Get Started
      .col-md-3
        .card-item
          h3 Extreme
          .number $400/mo
          p Monthly expenses up to $1M
          p Unlimited Accounts
          .text-center
            a.btn.btn-primary(href='#register') Get Started
  section#register.container
    h2 Ready to get started?
    p Fill out your contact information below and one of our consultants will contact you to learn more about your business and find the right plan for you!
    main-contact
</template>

<style lang="scss" scoped>
  .hello {
    h2 {
      text-align: left;
    }

    p {
      font-size: 16px;
      line-height: 30px;
      color: #616b77;
      margin: 0 auto;
      word-wrap: break-word;
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    section {
      padding-top: 4rem;
      padding-bottom: 2rem;
    }

    .card-item {
      background: #fff;
      border: 1px solid rgba(90,122,190,0.08);
      box-shadow: 0 3px 0 0 rgba(90,122,190,0.12);
      border-radius: 8px;
      padding: 20px;
      display: block;
      width: 360px;
      max-width: 100%;
      -webkit-transition: box-shadow .3s;
      transition: box-shadow .3s;
    }
  }

  #hero {
    background-color: #f9f9fa;
    // background-image: url('https://zipbooks.com/wp-content/uploads/2018/07/bg2.svg');
    background-size: cover;

    h2 {
      // color: #7953f5;
      font-weight: bold;
      font-size: 60px;
      max-width: 480px;
      margin-bottom: 14px;
    }

    p {
      font-size: 20px;
    }

    img {
      max-width: 100%;
      margin-top: -1rem;
    }
  }

  #how {
    h2 {
      text-align: center;
      margin-bottom: 2rem;
    }

    h3 {
      color: #7953f5;
    }

    .card-item {
      height: 260px;
    }
  }

  #pricing {
    h2 {
      margin-bottom: 2rem;
      text-align: center;
    }

    h3 {
      font-size: 20px;
      text-align: center;
      margin-top: 2rem;
    }

    .card-item {
      height: 400px;

      p {
        text-align: center;
      }

      p:first-of-type {
        height: 50px;
      }
    }

    .small-text {
      margin-top: 1rem;
      text-align: center;
    }

    .number {
      text-align: center;
      font-size: 36px;
      color: #7953f5;
    }
  }

  #register {
    h2 {
      text-align: center;
    }

    p {
      width: 400px;
    }
  }
</style>

<script>
import Account from './Account'
import MainContact from './MainContact'

export default {
  name: 'HomePage',
  components: {
    Account,
    MainContact
  },
  data () {
    return {
      msg: '',
      step: 1,
      email: '',
      phone: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue